import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Alert, Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import { email, maxLength, passwordCompare, required } from '@src/validation';
import connect from 'react-redux/es/connect/connect';
import LabelInput from '@src/components/LabelInput/LabelInput';
import axiosInstance from '@src/axios-instance';
import * as actions from '@src/store/actions';
import PasswordModal from '@src/components/AdminUsers/PasswordModal/PasswordModal';

const validator = {
  email: [required, email, value => maxLength(value, 255)],
  name: [required, value => maxLength(value, 64)]
};

class MyAccount extends Component {
  constructor(props) {
    super(props);

    const fields = {};
    Object.keys(validator).forEach(key => {
      fields[key] = {
        value:
          this.props[key] !== undefined && this.props[key] !== null
            ? this.props[key]
            : '',
        visited: false,
        error: false
      };
    });

    this.state = {
      ...fields,
      loaded: false,
      errorMessage: false,
      successMessage: false,
      validator: validator,
      modalPasswordActive: false,
      passwordError: false,
      entity: {}
    };
  }

  toggle = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType],
      passwordError: false
    }));
  };

  componentDidUpdate(prevProps, prevState) {
    const fields = {};
    if (!this.state.loaded && this.props.email !== '') {
      Object.keys(this.state.validator).forEach(key => {
        fields[key] = {
          value:
            this.props[key] !== undefined && this.props[key] !== null
              ? this.props[key]
              : '',
          visited: false,
          error: false
        };
      });

      this.setState({
        ...fields,
        loaded: true,
        errorMessage: false
      });
    }
  }

  componentDidMount = () => {
    document.getElementById('root').click();
  };

  updateForm = (event, name) => {
    const inputData = {
      value: event.target.value,
      visited: true,
      error: false
    };

    for (let i = 0; i < this.state.validator[name].length; i++) {
      const validationMsg = this.state.validator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }
    if (name === 'repassword' && inputData.error === false) {
      let validationPass = passwordCompare(
        inputData.value,
        this.state.password.value
      );
      if (validationPass !== undefined) {
        inputData.error = validationPass;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  changePassword = postData => {
    axiosInstance()
      .put(`/users/update-my-account.json`, postData)
      .then(response => {
        this.setState({
          modalPasswordActive: false,
          passwordError: false
        });
      })
      .catch(err => {
        this.setState({
          passwordError: err.response.data.message
        });
      });
  };

  onSubmit = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(this.state.validator).forEach(key => {
      postData[key] = formData[key].value;
      for (let i = 0; i < this.state.validator[key].length; i++) {
        const validationMsg = this.state.validator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    formData.validator = validator;
    this.setState({ ...formData, successMessage: false, errorMessage: false });

    if (isValid) {
      axiosInstance()
        .put(`/users/update-my-account.json`, postData)
        .then(response => {
          this.setState({
            errorMessage: false,
            successMessage: 'Cool! Your account has been updated. '
          });
          this.props.updateStore(this.state.email.value, this.state.name.value);
        })
        .catch(err => {
          this.setState({
            errorMessage: err.response.data.message
          });
        });
    }
    return false;
  };

  render = () => {
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | Manage My Account</title>
        </Helmet>
        <div>
          <h3>Manage My Account</h3>
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col xs={12} md={6}>
                      {this.state.errorMessage !== false && (
                        <Alert color={'danger'}>
                          {this.state.errorMessage}
                        </Alert>
                      )}
                      {this.state.successMessage !== false && (
                        <Alert color={'success'}>
                          {this.state.successMessage}
                        </Alert>
                      )}
                      <LabelInput
                        name={'Email'}
                        type={'email'}
                        required={true}
                        {...this.state.email}
                        onChange={event => this.updateForm(event, 'email')}
                      />
                      <LabelInput
                        name={'Name'}
                        type={'text'}
                        required={true}
                        {...this.state.name}
                        onChange={event => this.updateForm(event, 'name')}
                      />
                      <Button
                        color="primary"
                        className={'btn px-3'}
                        type={'submit'}
                        onClick={this.onSubmit}
                      >
                        Save
                      </Button>
                    </Col>
                  </Row>
                  <hr />
                  <Button
                    color="primary"
                    className={'btn px-3'}
                    type={'submit'}
                    onClick={() => this.toggle('modalPasswordActive')}
                  >
                    Reset My Password
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>

        {this.state.modalPasswordActive && (
          <PasswordModal
            isActive={this.state.modalPasswordActive}
            toggle={entity => this.toggle('modalPasswordActive')}
            onSubmit={postData => this.changePassword(postData)}
            entity={{ email: this.props.email }}
            error={this.state.passwordError}
          />
        )}
      </Container>
    );
  };
}

const mapStateToProps = state => {
  return {
    email: state.auth.email,
    name: state.auth.name
  };
};
const mapDispatchToProps = dispatch => {
  return {
    updateStore: (email, name) => dispatch(actions.updateAccount(email, name))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyAccount);
